import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import CrossSvg from "../../assets/svg/CrossSvg";
import InfoSvg from "../../assets/svg/InfoSvg";
import "./ModalWindow.scss";
import gsap from "gsap";

function ModalWindow({ open, setOpen, description, children }) {
    const [isRender, setIsRender] = useState(false);
    const modalRef = useRef(null);
    const backdropRef = useRef(null);
    const bodyRef = useRef(document.body)

    const onClickClose = () => {
        setOpen(false)
        setIsRender(true)
    }

    useEffect(() => {
        const body = bodyRef.current;

        if (open) {
            body.style.overflow = "hidden";
            body.style.touchAction = "none";
            gsap.fromTo(backdropRef.current, {opacity: 0}, {opacity: 1, duration: .3, ease: "power2.out"})
            gsap.fromTo(modalRef.current, {opacity: 0, translateY: 0, scale: .6}, {
                opacity: 1,
                scale: 1,
                translateY: 0,
                duration: .3,
                ease: "power2.out"
            })
        } else if (!open && isRender) {
            gsap.to(backdropRef.current, {opacity: 0, duration: .2, ease: "power2.in"})
            gsap.to(modalRef.current, {
                translateY: 0,
                opacity: 0,
                scale: .6,
                duration: .2,
                ease: "power2.in",
                onComplete: () => setIsRender(false)
            })
        }

        return () => {
            body.style.overflow = "";
            body.style.touchAction = "";
        };
    }, [open, isRender])

    if (!open && !isRender) {
        return null
    }

    return ReactDOM.createPortal(
        <div className="modal-backdrop" ref={backdropRef} onClick={onClickClose}>
            <div className="modal-wrapper" ref={modalRef} onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div className="modal-header-right">
                        <div className="modal-info-icon"><InfoSvg /></div>
                        <div className="modal-description">{description}</div>
                    </div>
                    <div className="modal-close-button" onClick={onClickClose}><CrossSvg /></div>
                </div>
                
                <div className="modal-content">{children}</div>
            </div>
        </div>,
        document.getElementById("modal-root")
    )
}

export default ModalWindow;